import { LinkText } from '@components/LinkText';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableNoResult } from '@components/Table/TableNoResult';
import { IData } from '@hooks/useData';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IRetornoItem } from '@model/RetornoItem';
import { useRetornoItemStatusColor } from '@model/RetornoItemStatus';
import { IRetornoItemFilter } from '@services/RetornoService';
import React from 'react';

export type RetornoDetalheTableProps = {
    data: IData<IRetornoItem, IRetornoItemFilter>
}

export function RetornoDetalheTable ({ data }: RetornoDetalheTableProps) {
    const retornoItemStatusColor = useRetornoItemStatusColor();

    return (
        <TableNoResult itemCount={data.itemsCount}>
            <TableHead>
                <TableRow>
                    <TableHeaderCell>ID</TableHeaderCell>
                    <TableHeaderCell>Fatura</TableHeaderCell>
                    <TableHeaderCell>Cliente</TableHeaderCell>
                    <TableHeaderCell>Ocorrência</TableHeaderCell>
                    <TableHeaderCell>Descrição</TableHeaderCell>
                    <TableHeaderCell>Status</TableHeaderCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {
                    data.items.map((retornoItem, index) => {
                        return (
                            <TableRow key={index}>
                                <TableKeyCell>{retornoItem.retornoItemId}</TableKeyCell>
                                <TableCell>{retornoItem.faturaId}</TableCell>
                                <TableCell><LinkText to={`/cliente/${retornoItem.faturaClienteId}`} text={retornoItem.faturaClienteNome} /></TableCell>
                                <TableCell>{retornoItem.codigoMotivoOcorrencia}</TableCell>
                                <TableCell>{retornoItem.descricaoMovimentoRetorno}</TableCell>
                                <TableCell className={retornoItemStatusColor[retornoItem.retornoItemStatusId]}>{retornoItem.retornoItemStatusNome}</TableCell>
                            </TableRow>
                        )
                    })
                }
            </TableBody>
        </TableNoResult>
    )
}